import { Component, OnInit } from '@angular/core';
import { Crisp } from 'crisp-sdk-web';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  openChat() {
    Crisp.chat.open();
  }
}
